module.exports = __webpack_public_path__ + "static/media/buzon-rojo-plantas.f8a266af.png";